import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";

import api from "./api";
Vue.prototype.$api = api;
Vue.prototype.$url = (url) => {
    return location.origin + location.pathname + "?t=" + new Date().getTime() + "#/" + url;
};

Vue.prototype.$f = function (n, status) {
    if (status) {
        return ($(window).width() / 1920) * n;
    } else {
        return ($(window).width() / 1920) * n + "px";
    }
};

import "./util/position.js";

// import dayjs from 'dayjs'
// Vue.prototype.$dayjs = dayjs

import auth from "./util/auth";
Vue.use(auth);

import cookies from "vue-cookies";
Vue.use(cookies);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts
import * as echarts from "echarts";
import "echarts/extension/bmap/bmap.js";
Vue.prototype.$echarts = echarts;

// import hotkeys from 'hotkeys-js'
// Vue.prototype.$hotkeys = hotkeys

import "xe-utils";
import VxeUIAll from "vxe-pc-ui";
import "vxe-pc-ui/es/style.css";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";

Vue.use(VxeUIAll);
Vue.use(VXETable);
import BaiduMap from "vue-baidu-map";

Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    // ak: "KYhaQOsNC3lyF3V9dFByJGybrw9QBEmK",
    ak: "1LjIf5Xu548eVty2ygWB0lGsx1ZrTeFS",
});

// 全局组件自动注册
import "./components/autoRegister";

// 自动加载 svg 图标
const req = require.context("./assets/icons", false, /\.svg$/);
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
requireAll(req);

import "./assets/styles/reset.scss";
// import './mock'
import "./util/filter.js";
import "./constants/index.js";

Vue.config.productionTip = false;

const app = new Vue({
    data() {
        return {
            d: {},
        };
    },
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
Vue.prototype.$eventBus = app;
import httpApi from "@/api/http.api.js";
Vue.use(httpApi, app);
